/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationProductMutation($input: SaveSimulationProduct_M_simulation_productInput!) {
    saveSimulationProduct_M_simulation_product(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
